import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import AllUsers from '../pages/UserManagement/AllUsers';
import BlockedUsers from '../pages/UserManagement/BlockedUsers';
import Permissions from '../pages/UserManagement/PermissionsTable';
import UserPermissionsPage from '../pages/UserManagement/UserPermissionsPage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import PermissionProtectedRoute from './PermissionProtectedRoute';

const userRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    {/* ✅ Lista de Usuarios */}
    <Route
      path="/user-management/users"
      element={
        <>
          <PageTitle title="Lista de Usuarios | POS System" />
          <AllUsers />
        </>
      }
    />
    <Route
      path="/user-management/users/page/:page"
      element={
        <>
          <PageTitle title="Lista de Usuarios | POS System" />
          <AllUsers />
        </>
      }
    />

    {/* ✅ Usuarios Bloqueados */}
    <Route
      path="/user-management/blocked-users"
      element={
        <>
          <PageTitle title="Usuarios Bloqueados | POS System" />
          <BlockedUsers />
        </>
      }
    />
    <Route
      path="/user-management/blocked-users/page/:page"
      element={
        <>
          <PageTitle title="Usuarios Bloqueados | POS System" />
          <BlockedUsers />
        </>
      }
    />

    {/* ✅ Gestión de Permisos — panel solo-SUPPORT (PERMISSIONS_MANAGE). */}
    <Route element={<PermissionProtectedRoute perm="PERMISSIONS_MANAGE" />}>
      <Route
        path="/user-management/permissions"
        element={
          <>
            <PageTitle title="Gestión de Permisos | POS System" />
            <Permissions />
          </>
        }
      />

      {/* ✅ Permisos por Usuario — mismo gate solo-SUPPORT que el panel de roles. */}
      <Route
        path="/user-management/user-permissions"
        element={
          <>
            <PageTitle title="Permisos por Usuario | POS System" />
            <UserPermissionsPage />
          </>
        }
      />
    </Route>
  </Route>
);

export default userRoutes;
